import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../styles';
import { translate } from '../translate';

export const Header = ({ order }) => (
    <>
      <Text style={styles.normalText}>
        {order.draft && translate('header.draft')}
        {!order.draft && translate('header.title')}
      </Text>
      <View style={styles.header}>
        <Text style={styles.normalText}>
          {translate('header.contractInfo', {
            nummer: order.orderId,
            date: '',
          })}
        </Text>
        <Text style={styles.normalText}>{order.createDate}</Text>
      </View>
    </>
);
